import { ReactElement } from 'react'
import { RectangularShapeDrawer } from '@structuralPlanningComponents'
import { v4 as uuid } from 'uuid'
import { DEFAULT_SLAB_LIKE_SETTINGS } from '@editor/pages/StructuralPlanning/components/PlanSettingsForm/utils'
import { useModelStore } from '@editorStores'
import { useGuidToElement, useTypeInteraction } from '@editorHooks'
import { calculateBeamGeometry } from 'src/utils'

interface Props {
  setActiveElement: (guid: string) => void
  resetMode: () => void
}

const verticalSlabTypeInteraction: ElementTypes[] = ['roof_slabs', 'vertical_roof_slabs']

const VerticalSlabDrawer3D = ({ setActiveElement, resetMode }: Props): ReactElement => {
  const setBlockingElement = useModelStore(state => state.setBlockingElement)

  useTypeInteraction(verticalSlabTypeInteraction)

  const addVerticalSlab = useModelStore(state => state.addSlab)
  const elements = useGuidToElement()

  return (
    <RectangularShapeDrawer
      onRoofDrawStart={() => setBlockingElement('vertical_slabs', true)}
      onRoofDrawEnd={() => setBlockingElement('vertical_slabs', false)}
      resetMode={resetMode}
      onElementDrawn={(target, points) => {
        const targetElement = elements[target]
        const slabGuid = uuid()
        const beamGuid = uuid()
        const relativePosition = 0.5

        // Calculate beam geometry using utility function
        const { start: startPoint, end: endPoint } = calculateBeamGeometry(points, relativePosition)

        const slab: VerticalSlab = {
          guid: slabGuid,
          shape: { points },
          storey: targetElement.storey,
          element_type: 'vertical_slabs' as ElementTypes,
          is_local: true,
          element_guid: beamGuid,
          ...DEFAULT_SLAB_LIKE_SETTINGS,
          beam: {
            guid: beamGuid,
            element_guid: beamGuid,
            slab_guid: slabGuid,
            relative_position: relativePosition,
            element_type: 'slab_beams' as ElementTypes,
            shape: {
              start: startPoint,
              end: endPoint,
            },
            storey: targetElement.storey,
            is_local: true,
          } as SlabBeam,
          step_size: 0,
        }

        setActiveElement(slab.guid)
        addVerticalSlab(slab)
      }}
      type="vertical_slabs"
      drawElements={['slabs', 'roof_slabs']}
    />
  )
}

export default VerticalSlabDrawer3D
